module.exports = __webpack_public_path__ + "static/media/1_step 2 & 3.04952e09.JPG";